<script>
  import debounce from "lodash.debounce";
  import { onMount } from "svelte";
  import { windowWidth, windowHeight, isPortrait } from "../stores/global.js";
  export let debounceDur = 50;

  const onResize = () => {
    $windowWidth = window.innerWidth;
    $windowHeight = window.innerHeight;
    $isPortrait = window.matchMedia("(orientation: portrait)").matches;
  };

  onMount(() => {
    onResize();
  });
</script>

<svelte:window on:resize={debounce(onResize, debounceDur)} />
